import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=33427b8e&scoped=true"
import script from "./EmailDetail.vue?vue&type=script&lang=js"
export * from "./EmailDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=33427b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33427b8e",
  null
  
)

export default component.exports